import { createTheming } from '@callstack/react-theme-provider';

import { LIGHT_THEME } from './lightTheme';

export const { ThemeProvider, withTheme, useTheme } = createTheming(LIGHT_THEME);
